// eslint-disable-next-line max-classes-per-file
import React, { Component } from "react";
import { Table, Spin, Switch } from "antd";
import { DndProvider, DragSource, DropTarget } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
// import { ExclamationCircleOutlined } from "@ant-design/icons";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { arrayMove } from "react-sortable-hoc";
import Swal from "sweetalert2";
import { Layout } from "../../containers";
import { userAction } from "../../../store/action";
import { cmsApi } from "../../../apis";
import { TagStatus } from "../../commons";
import moment from "moment";
import "moment/locale/th";
import { refreshToken } from "../../utils/refreshToken";

let dragingIndex = -1;

class BodyRow extends Component {
  render() {
    const {
      isOver,
      connectDragSource,
      connectDropTarget,
      moveRow,
      ...restProps
    } = this.props;
    const style = { ...restProps.style, cursor: "move" };

    let { className } = restProps;
    if (isOver) {
      if (restProps.index > dragingIndex) {
        className += " drop-over-downward";
      }
      if (restProps.index < dragingIndex) {
        className += " drop-over-upward";
      }
    }

    return connectDragSource(
      connectDropTarget(
        <tr {...restProps} className={className} style={style} />,
      ),
    );
  }
}

const rowSource = {
  beginDrag(props) {
    dragingIndex = props.index;
    return {
      index: props.index,
    };
  },
};

const rowTarget = {
  drop(props, monitor) {
    const dragIndex = monitor.getItem().index;
    const hoverIndex = props.index;
    if (dragIndex === hoverIndex) {
      return;
    }
    props.moveRow(dragIndex, hoverIndex).then();
    monitor.getItem().index = hoverIndex;
  },
};

const DragableBodyRow = DropTarget("row", rowTarget, (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver(),
}))(
  DragSource("row", rowSource, (connect) => ({
    connectDragSource: connect.dragSource(),
  }))(BodyRow),
);

class NewsStickyDataTable extends Component {
  constructor(props) {
    super(props);
    this.components = {
      body: {
        row: DragableBodyRow,
      },
    };
    this.state = {
      loading: false,
      visible: false,
      data: [],
      dataPrint: [],
      start: 0,
      length: 10,
      search: "",
      total: 0,
      check_token: false,
    };
  }

  componentDidMount = () => {
    this.checkToken();
  };

  componentWillUnmount() {
    clearInterval(this.timeout);
  }

  checkToken = async () => {
    const now = moment().unix();
    if (now >= localStorage.getItem("exp_access_token")) {
      const check = await refreshToken();
      if (check) {
        this.timeout = setTimeout(() => {
          this.fetchData();
        }, 1);
      } else {
        window.location.href = "/";
      }
    } else {
      this.fetchData();
    }
  };

  fetchData = async () => {
    this.setState({
      check_token: true,
    });
    await this.setState({ loading: true });
    const { start, length } = this.state;
    await cmsApi
      .NewsStickyTable(start, length)
      .then((resp) => {
        this.setState((prevState) => ({
          ...prevState,
          data: resp.data,
          total: resp.recordsTotal,
          loading: false,
        }));
      })
      .catch((error) => {
        this.setState({ loading: false });
        throw error;
      });
  };

  handlePaggination = (start, length, search) => {
    this.setState({ loading: true });
    this.setState((prevState) => ({
      ...prevState,
      start,
      length,
      search,
    }));
    cmsApi
      .NewsStickyTable(start, length)
      .then((resp) => {
        this.setState((prevState) => ({
          ...prevState,
          data: resp.data,
          total: resp.recordsTotal,
          loading: false,
        }));
      })
      .catch((error) => {
        this.setState({ loading: false });
        throw error;
      });
  };

  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleCancel = () => {
    this.setState({
      visible: false,
    });
  };

  onSticky = (e, id) => {
    cmsApi.updateStickyNews(id).then(() => {
      Swal.fire({
        icon: "success",
        title: `Success`,
        timer: 1500,
        showConfirmButton: false,
      }).then(() => {
        this.setState({
          loading: false,
        });
        this.componentDidMount();
      });
    });
  };

  moveRow = async (oldIndex, newIndex) => {
    await this.setState({
      data: arrayMove(this.state.data, oldIndex, newIndex),
    });
    const list = [];
    for (let i = 0; i < this.state.data.length; i += 1) {
      list.push({
        id: this.state.data[i].id,
        index: i + 1,
      });
    }
    cmsApi.indexNews({ obj: list }).catch((error) => {
      throw error;
    });
  };

  render() {
    const { loading, data, total, check_token } = this.state;

    const columns = [
      {
        title: "Title",
        dataIndex: "title",
        id: "title",
        type: "input",
        value: "",
        selectData: [],
      },
      {
        title: "Auther",
        dataIndex: "auther",
        key: "auther",
        type: "select",
        value: "all",
        selectData: [],
      },
      {
        title: "Pubish date",
        dataIndex: "date",
        key: "date",
        type: "date",
        value: "",
        selectData: [],
        onChange: () => console.log("ok"),
        render: (text, record) => <span>{record.end_date_conver}</span>,
      },
      {
        title: "Status",
        dataIndex: "status",
        key: "status",
        type: "select",
        value: "all",
        selectData: [],
        render: (text) => <TagStatus StatusValue={+text} />,
      },
      {
        title: "Index",
        dataIndex: "index",
        key: "index",
        align: "right",
        render: (text, record, index) => <span>{index + 1}</span>,
      },
      {
        title: "Sticky",
        dataIndex: "sticky",
        key: "sticky",
        type: "select",
        value: "all",
        selectData: [],
        render: (text, record) => (
          <Switch
            onChange={(e) => this.onSticky(e, record.id)}
            defaultChecked
          />
        ),
      },
    ];

    return (
      <>
        {check_token === true && (
          <Layout
            title="News Sticky"
            extraBtn={[]}
            breadcrumbNav={[
              {
                path: "dashboard",
                breadcrumbName: "Dashboard",
              },
              {
                path: "news",
                breadcrumbName: "News",
              },
              {
                path: "sticky",
                breadcrumbName: "News Sticky",
              },
            ]}
          >
            <Spin spinning={loading} tip="Loading...">
              <DndProvider backend={HTML5Backend}>
                <Table
                  className="mt-4"
                  rowKey={(record) => record.id}
                  columns={columns}
                  dataSource={data}
                  components={this.components}
                  onRow={(record, index) => ({
                    index,
                    moveRow: this.moveRow,
                  })}
                  pagination={{
                    showSizeChanger: total <= 20 ? false : true,
                    showQuickJumper: true,
                    total,
                    onChange: (page, length) => {
                      this.handlePaggination(
                        (page - 1) * length,
                        length,
                        "",
                        page,
                        length,
                      );
                    },
                    showTotal: (total) => `รายการทั้งหมด ${total} รายการ`,
                    pageSizeOptions: ["10", "20", "30"],
                    onShowSizeChange: (page, length) => {
                      this.handlePaggination(0 * length, length, "", 1, length);
                    },
                  }}
                />
              </DndProvider>
            </Spin>
          </Layout>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  role: state.users ? state.users.role : 0,
});

const mapDispatchToProps = (dispatch) => ({
  userAction: bindActionCreators(userAction, dispatch),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NewsStickyDataTable);
